import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

const prefix = '/api/v1/profiles/me/contributor_profile/';

export function useGetContributorProfile() {
  return useAxios({
    url: prefix.slice(0, -1),
    method: 'GET',
    cache: { ignoreCache: true },
  }, { manual: true });
}

export function usePostUpdateJoinedCurrentRoleAt() {
  const common = value => ({ data: { value } });
  const [state, q] = useAxios({
    url: `${prefix}_update_joined_current_role_at`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePostUpdateJoinedIndustryAt() {
  const common = value => ({ data: { value } });
  const [state, q] = useAxios({
    url: `${prefix}_update_joined_industry_at`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePostUpdateInvestmentPhilosophy() {
  const common = values => ({ data: { investment_philosophy: values } });
  const [state, q] = useAxios({
    url: `${prefix}_update_investment_philosophy`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePostUpdateHeadlineGrab() {
  const common = value => ({ data: { headline_grab: value } });
  const [state, q] = useAxios({
    url: `${prefix}_update_headline_grab`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePostUpdateAccred() {
  const common = value => ({ data: { value } });
  const [state, q] = useAxios({
    url: `${prefix}_update_accred`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePostUpdateLocation() {
  const common = ({ country, city }) => ({ data: { country_id: country, city_id: city } });
  const [state, q] = useAxios({
    url: `${prefix}_update_location`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePostUpdateRecentCareer() {
  const common = ({
    joinedAt, leftAt, organisation, position,
  }) => ({
    data: {
      joined_at: joinedAt,
      left_at: leftAt,
      organisation,
      position,
    },
  });
  const [state, q] = useAxios({
    url: `${prefix}_update_recent_career`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function useDeleteRecentCareer() {
  return useAxios({
    url: `${prefix}_delete_recent_career`,
    method: 'DELETE',
  }, { manual: true });
}

export function usePostUpdateLinkedInUrl() {
  const common = value => ({ data: { linkedin_url: value } });
  const [state, q] = useAxios({
    url: `${prefix}_update_linkedin_url`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePostUpdateTwitterUrl() {
  const common = value => ({ data: { twitter_url: value } });
  const [state, q] = useAxios({
    url: `${prefix}_update_twitter_url`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePostUpdateDisclaimer() {
  const common = disclaimer => ({ data: { disclaimer } });
  const [state, q] = useAxios({
    url: `${prefix}_update_disclaimer`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePostUpdateBlurb() {
  const common = blurb => ({ data: { blurb } });
  const [state, q] = useAxios({
    url: `${prefix}_update_blurb`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function postToggleAreaOfExpertise({ assignedToMe, slug }) {
  const url = `${prefix}_${assignedToMe ? 'unassign' : 'assign'}_area_of_expertise_to_me`;
  return axios.post(url, { slug });
}
